module.exports = __webpack_public_path__ + "static/media/notebookDefault.70cfa285.png";